import { ArrowLeft, ArrowRight } from "lucide-react";
import Button from "../Button/Button";
import { useNavigate } from "react-router-dom";

export default function OnboardingControls({
  question,
  setQuestionFunction,
  answers,
  questions,
}) {
  const totalQuestionsWithoutTestimonials = questions.filter(
    (q) => q.type !== "testimonial"
  ).length;
  const currentQuestion = questions.find((q) => q.number === question);
  const navigate = useNavigate();

  const isNextDisabled = () => {
    if (question === 5) {
      if (answers[currentQuestion?.answerKey] === false) {
        return false;
      } else if (
        answers["extraInfoText"] === true &&
        answers["extraInfoText"].trim() === ""
      ) {
        return true;
      }
      return false;
    }

    return question === 2.5 || question === 4.5
      ? false
      : question > 0 && !answers[currentQuestion?.answerKey];
  };

  const handleNext = () => {
    if (question === totalQuestionsWithoutTestimonials) {
      navigate("/register");
    } else {
      const currentIndex = questions.findIndex((q) => q.number === question);
      if (currentIndex !== -1 && currentIndex < questions.length - 1) {
        setQuestionFunction(questions[currentIndex + 1].number);
      }
    }
  };

  const isMobile = window.innerWidth < 768;

  return (
    <div className="w-full fixed bottom-0 py-[24px] flex justify-center bg-gray-50 border-t border-gray-150">
      <div
        className={`md:mx-auto md:w-[40rem] w-full px-4 flex ${
          question === 0 ? "justify-center" : "justify-between"
        }`}
      >
        {question === 0 ? (
          <Button
            text="Partiamo"
            type="color"
            width={isMobile ? "full" : "fit"}
            size="md"
            onClick={() => setQuestionFunction(1)}
          />
        ) : (
          <div className="flex w-full md:justify-between gap-2">
            {isMobile ? (
              <Button
                icon={<ArrowLeft />}
                type="bw"
                size="lg"
                onClick={() => {
                  const currentIndex = questions.findIndex(
                    (q) => q.number === question
                  );
                  if (currentIndex > 0) {
                    setQuestionFunction(questions[currentIndex - 1].number);
                  }
                }}
              />
            ) : (
              <Button
                text="Indietro"
                type="bw"
                size="md"
                licon={<ArrowLeft size={20} />}
                disabled={question === 1}
                onClick={() => {
                  const currentIndex = questions.findIndex(
                    (q) => q.number === question
                  );
                  if (currentIndex > 0) {
                    setQuestionFunction(questions[currentIndex - 1].number);
                  }
                }}
              />
            )}

            <Button
              text={
                question === totalQuestionsWithoutTestimonials
                  ? "Concludi"
                  : "Avanti"
              }
              type="color"
              size="md"
              width={isMobile ? "full" : "fit"}
              disabled={isNextDisabled()}
              ricon={<ArrowRight size={20} />}
              onClick={handleNext}
            />
          </div>
        )}
      </div>
    </div>
  );
}
